import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { useLayoutContext } from '../../../providers/LayoutProvider';
import { queryBuilder } from '../../../shared/Utils';
import { Chip } from '../../../components/Chip/Chip';
import { createArticlePreviewCards } from '../../../shared/createArticlePreviewCards';
import './ArticleAside.scss';

export interface ArticleAsideProps {
    recentArticles: any;
    relatedArticles: any;
    categoryChips?: boolean;
}

export const ArticleAside = (props: ArticleAsideProps) => {
    const { campaignTermsFilter } = useLayoutContext();
    const [displayCategories, setDisplayCategories] = useState<boolean>(true);
    const [queryString, setQueryString] = useState(``);
    const queryParametersToString = queryBuilder(campaignTermsFilter, false);
    const data = useStaticQuery(graphql`
        query {
            allTaxonomyTermArticleCategories(sort: { name: ASC }) {
                nodes {
                    name
                }
            }
        }
    `);

    useEffect(() => {
        setQueryString(
            `${!queryParametersToString ? `` : queryParametersToString}`
        );
    }, [queryParametersToString]);

    useEffect(() => {
        setDisplayCategories(props.categoryChips ?? true);
    }, []);

    return (
        <aside className="c--article-aside">
            {props.relatedArticles?.nodes?.length > 0 && (
                <nav className="cards">
                    <h2>Related Articles</h2>
                    {createArticlePreviewCards(props.relatedArticles?.nodes)}
                </nav>
            )}
            <nav className="cards">
                <h2>Recent Articles</h2>
                {createArticlePreviewCards(props.recentArticles?.nodes)}
            </nav>
            {displayCategories && (
                <nav className="gray">
                    <h2>Categories</h2>
                    <div className="chips">
                        {data.allTaxonomyTermArticleCategories?.nodes.map(
                            (c, idx) => (
                                <Chip key={idx}>{c.name}</Chip>
                            )
                        )}
                    </div>
                </nav>
            )}
            <div className="connect">
                <h2>Connect With Us</h2>
                <iframe
                    src={`https://go2.spectrumreach.com/l/211312/2022-10-26/8bms4m${queryString}`}
                ></iframe>
            </div>
        </aside>
    );
};
